import { requestApi } from '@app/api';
import { withSubscription } from '@app/api/paths';
import AvailableFeatureAction from '@app/features/subscription/types/AvailableFeatureAction';
import { PaymentItemType } from '@app/features/subscription/types/PaymentItemType';

interface Plan {
  applicationId?: string;
  defaultSeat: number;
  grade: number;
  id: string;
  price: number;
  resetPeriod: {
    value: number;
    unit: 'MONTH';
  };
  seatUnitPrice: number;
  suppliedResetCount: number;
  title: string;
}

interface Seat {
  quota: number;
}

export interface Subscription {
  createdAt: string;
  currentTimes: number;
  id: string;
  isSubscribing: boolean;
  maxTimes: number;
  nextInvoicingDate: string | null;
  nextPlan: Plan | null;
  nextResetDate: string | null;
  plan: Plan;
  remainingResetCount: number;
  resetDateOfMonth: number | null;
  seat: Seat | null;
  status: 'READY' | 'ACTIVE' | 'STOPPED';
  updatedAt: string;
  userId: string;
  userName: string;
  workspaceId: string;
}

export type GetSubscriptionResponse = Subscription;

/**
 * 정기 결제 조회
 * @returns {Subscription} - 정기 구독 정보
 */
export function getSubscription(workspaceId: string): Promise<GetSubscriptionResponse> {
  return requestApi<GetSubscriptionResponse>({
    url: withSubscription(`/workspaces/${workspaceId}/subscription`),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data);
}

interface PlanItem {
  type: Extract<PaymentItemType, 'PLAN'>;
  planId: string;
}

interface AvailableFeatureItem {
  action: AvailableFeatureAction;
  quantity: number;
  type: Extract<PaymentItemType, 'AVAILABLE_FEATURE'>;
}

export type CreateSubscriptionResponse = Subscription;

export function createSubscription(
  workspaceId: string,
  data: {
    activation: boolean;
    items: Array<AvailableFeatureItem | PlanItem>;
  }
): Promise<CreateSubscriptionResponse> {
  return requestApi<CreateSubscriptionResponse>({
    url: withSubscription(`/workspaces/${workspaceId}/subscription`),
    method: 'POST',
    credentials: true,
    data,
  }).then((response) => response.data);
}
